import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { TslDialog, TslToastrService } from '@tesla/ng-tds';
import { DiversityEditComponent } from 'app/common/diversity/diversity-edit.component';
import { OnboardingTab, SupplierDiversity, TaskStatus } from 'app/profile/models/onboarding.model';
import { ContextVerbiage } from 'app/profile/models/supplier.model';
import { SupplierTaskResponse } from 'app/profile/models/suppliertasks.model';
import { SupplierTaskService } from 'app/profile/services/supplier-task.service';
import { OnboardingState } from 'app/profile/store/state/onboarding.state';
import { I18nService } from 'app/shared/services/i18n.service';
import { validateAllFormFields, validateAllFormGroupsInArrayForm } from 'app/shared/utils/utils';
import * as MasterDataSelectors from "../../../store/selectors/masterdata.selector";
@Component({
  selector: 'app-diversity-task-wrapper',
  templateUrl: './diversity-task-wrapper.component.html',
  styleUrls: ['./diversity-task-wrapper.component.scss']
})
export class DiversityTaskWrapperComponent implements OnInit {
  onboardingTab: OnboardingTab = OnboardingTab.DIVERSITY;
  supplierCode: string = '';
  taskId: number;
  @ViewChild('diversityEdit', { static: false }) diversityEditChild: DiversityEditComponent;
  supplierDiversity: SupplierDiversity = new SupplierDiversity();
  taskStatus: string;
  isLoaded: boolean = false;
  contextVerbiage: ContextVerbiage;
  @Input('supplierCode') set _supplierCode(val: string) { if (val && val.trim() != "") this.supplierCode = val; };
  @Input('taskId') set _taskId(val: number) { if (val) this.taskId = val; };
  @Input('isSidePanelMode') isSidePanelMode: boolean = false;
  @Output() onSave: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(private translate: I18nService,
    private tslDialog: TslDialog,
    private toaster: TslToastrService,
    private route: ActivatedRoute,
    private router: Router,
    private taskService: SupplierTaskService,
    private onboardingStore: Store<OnboardingState>,
  ) { }

  ngOnInit(): void {
    this.route?.parent?.params.subscribe(params => {
      if (params?.code && params?.portalTaskId) {``
        this.supplierCode = params.code;
        this.taskId = params.portalTaskId;
      }
    });

    this.onboardingStore.select(MasterDataSelectors.SelectContextVerbiage).subscribe(contextVerbiage => this.contextVerbiage = contextVerbiage);
    this.taskService.getSupplierTaskStep(this.supplierCode, this.taskId, this.onboardingTab).subscribe(taskInfo => {
      if (taskInfo) {
        this.taskStatus = taskInfo.taskStatus;
        if(this.taskStatus != TaskStatus.Completed && taskInfo.portalTaskResponse != null)
        {
          this.supplierDiversity = taskInfo.portalTaskResponse;
        }
        this.isLoaded = true;
      }
    });
  }

  onSubmit() {
    if (this.diversityEditChild && !this.diversityEditChild?.mainForm?.valid) {
      validateAllFormFields(this.diversityEditChild.mainForm);
      return;
    }

    if (this.diversityEditChild && !this.diversityEditChild?.documentGrid?.IsValid) {
      validateAllFormFields(this.diversityEditChild.documentGrid.formGroup);
      return;
    }

    var diversity = this.diversityEditChild?.getPayload();
    if (diversity) {
      const body: SupplierDiversity = { ...diversity };
      body.DocumentIds = body.Documents?.map(x => x.DocumentID);
      var response: SupplierTaskResponse = {
        id: this.taskId,
        supplierCode: this.supplierCode,
        taskResponseJson: JSON.stringify(body)
      }

      this.taskService.postSupplierTaskStepResponse(this.supplierCode, response).subscribe(res => {
        if (res) {
          this.toaster.success('Submitted successfully!');
          if (this.isSidePanelMode) this.onSave.emit(true);
          else this.router.navigate([`${this.supplierCode}`, "Onboarding", "Home"]);
        }
        else {
          this.toaster.error('Something went wrong!');
        }
      });
    }
  }

  navigateToHome(){
    this.router.navigate([`${this.supplierCode}`, "Onboarding", "Home"]);
  }
}
